import React from 'react';
import SharedActivity from '@/components/shared/Activity';

interface ActivityProps {
  workerId: string;
}

const Activity: React.FC<ActivityProps> = ({ workerId }) => {
  return <SharedActivity objectId={workerId || ''} title="Activity" />;
};

export default Activity;
